import { useQuery, useMutation } from "@tanstack/react-query";
import {
  getInitsTicket,
  getTickets,
  getTicketTags,
  createTicket,
  getTicketById,
  postCommentTicket,
  deleteCommentTicket,
  updateTicket,
  createTabFilter,
  updateTabFilter,
  deleteTabFilter,
  postTagTicketing,
  deleteTicket,
  getInboxTicketing,
  createInboxTicketing,
  updateInboxTicketing,
  deleteInboxTicketing,
} from "apis/ticketing";
import { setLoadingInitTicket } from "appredux/configSlice";
import { useAntdMessage } from "hooks/useAntdMessage";
import { useDispatch } from "react-redux";

export function useInitsTicket(options = {}) {
  const { notification } = useAntdMessage();
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["initsTicket"],
    queryFn: async () => {
      dispatch(setLoadingInitTicket(true));
      let response;
      try {
        const {
          data: { data },
        } = await getInitsTicket();
        response = data;
      } catch (error) {
        notification.warning({
          description: "Inits Ticket failed",
          key: "Inits Ticket failed",
        });
        throw new Error("Gagal mengambil data dari server!");
      }
      dispatch(setLoadingInitTicket(false));
      return response;
    },
    ...options,
  });
}

export function useTickets(params = {}, options = {}) {
  return useQuery({
    queryKey: ["tickets", params],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data: ticketsData },
        } = await getTickets(params);
        response = ticketsData;
      } catch (error) {
        throw new Error("Failed to fetch tickets from server!");
      }
      return response;
    },
    ...options,
  });
}

export function useTicketTags(options = {}) {
  return useQuery({
    queryKey: ["ticketTags"],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getTicketTags();
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useCreateTicket(options = {}) {
  return useMutation({
    mutationFn: (payload) => createTicket(payload),
    ...options,
  });
}

export function useTicketById(id, options = {}) {
  return useQuery({
    queryKey: ["ticketById", id],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getTicketById(id);
        response = data;
      } catch (error) {
        throw new Error(
          error.response.data.message || "Gagal mengambil data dari server!"
        );
      }
      return response;
    },
    ...options,
  });
}

export function usePostCommentTicket(options = {}) {
  return useMutation({
    mutationFn: ({ id, ...payload }) => postCommentTicket(id, payload),
    ...options,
  });
}

export function useDeleteCommentTicket(options = {}) {
  return useMutation({
    mutationFn: (id) => deleteCommentTicket(id),
    ...options,
  });
}

export function useUpdateTicket(options = {}) {
  return useMutation({
    mutationFn: ({ id, payload }) => updateTicket(id, payload),
    ...options,
  });
}

export function useCreateTabFilter(options = {}) {
  return useMutation({
    mutationFn: (payload) => createTabFilter(payload),
    ...options,
  });
}

export function useUpdateTabFilter(options = {}) {
  return useMutation({
    mutationFn: ({ id, payload }) => updateTabFilter(id, payload),
    ...options,
  });
}

export function useDeleteTabFilter(options = {}) {
  return useMutation({
    mutationFn: (id) => deleteTabFilter(id),
    ...options,
  });
}

export function usePostTagTicketing(options = {}) {
  return useMutation({
    mutationFn: (payload) => postTagTicketing(payload),
    ...options,
  });
}

export function useDeleteTicket(options = {}) {
  return useMutation({
    mutationFn: (id) => deleteTicket(id),
    ...options,
  });
}

export function useGetInboxTicketing(options = {}, params = {}) {
  return useQuery({
    queryKey: ["inboxTicketing", params],
    queryFn: async () => {
      let response;
      try {
        const {
          data: { data },
        } = await getInboxTicketing(params);
        response = data;
      } catch (error) {
        throw new Error("Gagal mengambil data dari server!");
      }
      return response;
    },
    ...options,
  });
}

export function useCreateInboxTicketing(options = {}) {
  return useMutation({
    mutationFn: (payload) => createInboxTicketing(payload),
    ...options,
  });
}

export function useUpdateInboxTicketing(options = {}) {
  return useMutation({
    mutationFn: ({ id, payload }) => updateInboxTicketing(id, payload),
    ...options,
  });
}

export function useDeleteInboxTicketing(options = {}) {
  return useMutation({
    mutationFn: (id) => deleteInboxTicketing(id),
    ...options,
  });
}
